export default {
  'menu.statistics.java.os.network': {
    ko: 'Network traffic',
    ja: 'ネットワークトラフィック',
    en: 'Network traffic',
  },
  'menu.analstatic.statistics.top-list': {
    ko: 'Top N List',
    ja: 'トップ Nリスト',
    en: 'Top N List',
  },
  // BEGIN::Added.by.HJSeo.2026.06.19.
  'menu.analstatic.statistics.checklist': {
    ko: 'Checklist',
    ja: 'Checklist',
    en: 'Checklist',
  },
  // FINISH::Added.by.HJSeo.2026.06.19.
  // BEGIN::Added.by.HJSeo.2026.07.02. LEM 고객사 전용 정기점검(테스트/동시노출용)
  'menu.analstatic.statistics.checklist-lem': {
    ko: 'Checklist (LEM)',
    ja: 'Checklist (LEM)',
    en: 'Checklist (LEM)',
  },
  // FINISH::Added.by.HJSeo.2026.07.02.
  'menu.user.help': {
    ko: '도움말',
    ja: 'ヘルプ',
    en: 'Help',
  },
  'menu.preference.general.datasource': {
    ko: '데이터 소스',
    ja: 'データソース',
    en: 'Datasource',
  },
  'menu.statistics.abap.os.disk': {
    ko: 'Disk I/O',
    ja: 'ディスクI/O',
    en: 'Disk I/O',
  },
  'menu.statistics.abap.syslog': {
    ko: 'System Log',
    ja: 'システムログ',
    en: 'System Log',
  },
  'menu.statistics.abap.transaction.per.tcode': {
    ko: 'Per T-Code',
    ja: 'Tコード当り',
    en: 'Per T-Code',
  },
  'menu.realtime.detailview.java.jm': {
    ko: 'JVM Memory',
    ja: 'JVMメモリ',
    en: 'JVM Memory',
  },
  'menu.realtime.detailview.abap.ci': {
    ko: 'Central Instance',
    ja: 'セントラルインスタンス',
    en: 'Central Instance',
  },
  'menu.realtime.detailview.java.msc': {
    ko: 'Miscellaneous',
    ja: 'その他',
    en: 'Miscellaneous',
  },
  'menu.statistics.abap.process': {
    ko: 'Process',
    ja: 'プロセス',
    en: 'Process',
  },
  'menu.statistics.java.database': {
    ko: 'Database',
    ja: 'データベース',
    en: 'Database',
  },
  // FINISH::Modified.by.KWShin.2023.08.08.
  // BEGIN::Modified.by.KWShin.2024.10.02.
  'menu.realtime.detailview.abap.batch': {
    ko: 'Batch Job',
    en: 'Batch Job',
    ja: 'Batch Job',
  },
  // FINISH::Modified.by.KWShin.2024.10.02.
  // BEGIN::Added.by.KWShin.2026.07.16.
  'menu.preference': {
    ko: '시스템 관리',
    ja: 'システム管理',
    en: 'System Admin.',
  },
  // FINISH::Added.by.KWShin.2026.07.16.
  'menu.preference.general': {
    ko: 'General',
    ja: '一般',
    en: 'General',
  },
  'menu.statistics.abap.locks': {
    ko: 'Locks',
    ja: 'ロック',
    en: 'Locks',
  },
  'menu.realtime.detailview.abap': {
    ko: 'ABAP 상세',
    ja: '詳細ビュー',
    en: 'Detail View',
  },
  'menu.user.screen': {
    ko: '화면 설정',
    ja: '画面設定',
    en: 'Screen Settings',
  },
  'menu.statistics.abap.ci': {
    ko: 'Central Instance',
    ja: 'セントラルインスタンス',
    en: 'Central Instance',
  },
  'menu.preference.general.systemGroup': {
    ko: '시스템 그룹',
    ja: 'システムグループ',
    en: 'System Group',
  },
  'menu.preference.general.cycle': {
    ko: '수집 주기',
    ja: '収集間隔',
    en: 'Collection Cycle',
  },
  'menu.analstatic.statistics': {
    ko: '통계',
    ja: '統計',
    en: 'Statistics',
  },
  'menu.realtime.detailview.java.os': {
    ko: 'Operating System',
    ja: 'オペレーティングシステム',
    en: 'Operating System',
  },
  'menu.analstatic.analysis': {
    ko: '분석',
    ja: '分析',
    en: 'Analysis',
  },
  'menu.analstatic.analysis.exp-sql': {
    ko: 'Expensive SQL',
    ja: 'Expensive SQL',
    en: 'Expensive SQL',
    cn: 'Expensive SQL',
  },
  'menu.realtime.overview.system': {
    ko: 'System Overview',
    ja: 'システム概要',
    en: 'System Overview',
  },
  'menu.statistics.abap.sap.memory': {
    ko: 'SAP Memory',
    ja: 'SAPメモリ',
    en: 'SAP Memory',
  },
  'menu.statistics.abap.work.process': {
    ko: 'Work process',
    ja: 'ワークプロセス',
    en: 'Work process',
  },
  'menu.realtime.detailview.java': {
    ko: 'Java 상세',
    ja: 'Java詳細',
    en: 'Detail View',
  },
  'menu.statistics.java.thread.application': {
    ko: 'Application thread',
    ja: 'アプリのスレッド',
    en: 'Application thread',
  },
  'menu.statistics.java.os.fsys': {
    ko: 'File system',
    ja: 'ファイルシステム',
    en: 'File system',
  },
  'menu.realtime.detailview.java.log': {
    ko: 'Java Log',
    ja: 'Javaログ',
    en: 'Java Log',
  },
  'menu.statistics.java.http.session': {
    ko: 'HTTP Session',
    ja: 'HTTPセッション',
    en: 'HTTP Session',
  },
  'menu.statistics.java.class.loader': {
    ko: 'Class loader',
    ja: 'クラスローダー',
    en: 'Class loader',
  },
  'menu.user.alarm': {
    ko: '알림 설정',
    ja: 'アラーム設定',
    en: 'Notification Settings',
  },
  'menu.statistics.abap': {
    ko: 'ABAP Stack',
    ja: 'ABAPスタック',
    en: 'ABAP Stack',
  },
  'menu.realtime.detailview.abap.process': {
    ko: 'Process',
    ja: 'プロセス',
    en: 'Process',
  },
  'menu.realtime.overview.workprcs': {
    ko: 'Workprocess Overview',
    ja: 'ワークプロセスの概要',
    en: 'Workprocess Overview',
  },
  'menu.statistics.java.http': {
    ko: 'HTTP Provider',
    ja: 'HTTPプロバイダー',
    en: 'HTTP Provider',
  },
  'menu.user.keep.logon.on': {
    ko: '로그온 유지 설정하기',
    ja: 'ログオン維持を設定',
    en: 'Making logon status on',
  },
  'menu.statistics.java.jsp': {
    ko: 'JSP/Servlet',
    ja: 'JSP/サーブレット',
    en: 'JSP/Servlet',
  },
  'menu.statistics.java.service.status': {
    ko: 'Service status',
    ja: 'サービス状況',
    en: 'Service status',
  },
  'menu.statistics.abap.throughtput': {
    ko: 'Throughput',
    ja: 'スループット',
    en: 'Throughput',
  },
  'menu.statistics.java': {
    ko: 'Java Stack',
    ja: 'Javaスタック',
    en: 'Java Stack',
  },
  'menu.preference.batch.roletracker': {
    ko: 'Role 수집 / 이력 관리',
    ja: 'ロール収集/履歴管理',
    en: 'Role Collect / History',
  },
  'menu.statistics.abap.dump': {
    ko: 'Abap dump',
    ja: 'ABAPダンプ',
    en: 'Abap dump',
  },
  'menu.statistics.db.hana.memory': {
    ko: 'HANA Memory',
    ja: 'HANAメモリ',
    en: 'HANA Memory',
  },
  'menu.statistics.abap.os.network': {
    ko: 'Network traffic',
    ja: 'ネットワークトラフィック',
    en: 'Network traffic',
  },
  'menu.statistics.abap.update.record': {
    ko: 'Update record',
    ja: 'レコード更新',
    en: 'Update record',
  },
  'menu.realtime.overview': {
    ko: '개요',
    ja: '概要',
    en: 'Overview',
  },
  'menu.user.keep.logon.off': {
    ko: '로그온 유지 해제하기',
    ja: 'ログオン維持を解除',
    en: 'Making logon status off',
  },
  'menu.statistics.abap.transaction.per.task.type': {
    ko: 'Per task type',
    ja: 'タスクタイプ当り',
    en: 'Per task type',
  },
  'menu.statistics.abap.applog': {
    ko: 'Application Log',
    ja: 'アプリのログ',
    en: 'Application Log',
  },
  'menu.realtime.detailview.java.ut': {
    ko: 'User &amp; Thread',
    ja: 'User &amp; スレッド',
    en: 'User &amp; Thread',
  },
  'menu.analstatic': {
    ko: '분석 / 통계',
    ja: '分析/統計',
    en: 'Analysis / Statistics',
  },
  'menu.statistics.java.thread': {
    ko: 'Thread',
    ja: 'スレッド',
    en: 'Thread',
  },
  'menu.statistics.abap.sap.buffer': {
    ko: 'SAP Buffer',
    ja: 'SAPバッファ',
    en: 'SAP Buffer',
  },
  'menu.statistics.java.jvm': {
    ko: 'JVM',
    ja: 'JVM',
    en: 'JVM',
  },
  'menu.statistics.abap.workprcs.load': {
    ko: 'Work process load',
    ja: 'ワークプロセスロード',
    en: 'Work process load',
  },
  'menu.statistics.java.p4': {
    ko: 'RMI-P4',
    ja: 'RMI-P4',
    en: 'RMI-P4',
  },
  'menu.realtime.detailview.abap.os': {
    ko: 'Operating System',
    ja: 'オペレーティングシステム',
    en: 'Operating System',
  },
  'menu.preference.general.chartColor': {
    ko: '차트 설정',
    ja: 'チャート設定',
    en: 'Configuring chart',
  },
  'menu.statistics.abap.transaction': {
    ko: 'Transaction',
    ja: 'トランザクション',
    en: 'Transaction',
  },
  'menu.user.license': {
    ko: '라이선스',
    ja: 'ライセンス',
    en: 'license',
  },
  'menu.preference.general.system': {
    ko: '시스템',
    ja: 'システム',
    en: 'System',
  },
  'menu.analstatic.analysis.alert': {
    ko: 'ALERT Center',
    ja: 'アラートセンター',
    en: 'ALERT Center',
  },
  'menu.user.about': {
    ko: 'About OWLens',
    ja: 'OWLensについて',
    en: 'About OWLens',
  },
  'menu.statistics.java.os.disk': {
    ko: 'Disk I/O',
    ja: 'ディスクI/O',
    en: 'Disk I/O',
  },
  'menu.preference.batch.statistics': {
    ko: '통계 배치 / 이력 관리',
    ja: '統計バッチ/履歴管理',
    en: 'Statistics Batch / History',
  },
  'menu.statistics.abap.transaction.per.report': {
    ko: 'Per program',
    ja: 'プログラム当り',
    en: 'Per program',
  },
  'menu.statistics.abap.transaction.per.user': {
    ko: 'Per user',
    ja: 'ユーザー当り',
    en: 'Per user',
  },
  'menu.preference.general.meta': {
    ko: 'SAP Meta Data',
    ja: 'SAPメタデータ',
    en: 'SAP Meta Data',
  },
  'menu.realtime.detailview.abap.dbms': {
    ko: 'DBMS',
    ja: 'DBMS',
    en: 'DBMS',
  },
  // Added.by.HJSeo.2026.08.10.
  'menu.realtime.detailview.abap.hanadb': {
    ko: 'HANA DB',
    ja: 'HANA DB',
    en: 'HANA DB',
  },
  'menu.analstatic.analysis.userHistory': {
    ko: 'User History',
    ja: 'ユーザー履歴',
    en: 'User History',
  },
  'menu.statistics.abap.user': {
    ko: 'User',
    ja: 'ユーザー',
    en: 'User',
  },
  'menu.preference.prop': {
    ko: 'Properties',
    ja: 'プロパティ',
    en: 'Properties',
  },
  'menu.statistics.java.user': {
    ko: 'User',
    ja: 'ユーザー',
    en: 'User',
  },
  'menu.statistics.java.log.size': {
    ko: 'Log size',
    ja: 'ログサイズ',
    en: 'Log size',
  },
  'menu.statistics.java.heap.memory': {
    ko: 'Heap memory',
    ja: 'ヒープメモリ',
    en: 'Heap memory',
  },
  'menu.statistics.java.thread.system': {
    ko: 'System thread',
    ja: 'システムスレッド',
    en: 'System thread',
  },
  'menu.analstatic.analysis.context': {
    ko: 'Context Analyzer',
    ja: 'コンテキストアナライザ',
    en: 'Context Analyzer',
  },
  // BEGIN::Added.by.KWShin.2026.01.06.
  'menu.extra': {
    ko: '유틸리티',
    ja: 'Utilities',
    en: 'Utilities',
    cn: 'Utilities',
  },
  'menu.extra.auth': {
    ko: '권한관리',
    ja: 'AuthMan',
    en: 'AuthMan',
    cn: 'AuthMan',
  },
  'menu.extra.auth.rtrck-summary': {
    ko: 'Role Tracker Summary',
    ja: 'ロールトラッカーのサマリー',
    en: 'Role Tracker Summary',
  },
  'menu.extra.auth.rtrck-search': {
    ko: 'Role Tracker Search',
    ja: 'ロールトラッカーの検索',
    en: 'Role Tracker Search',
  },
  'menu.extra.auth.sod': {
    ko: 'SoD & RA',
    ja: 'SoD & RA',
    en: 'SoD & RA',
    cn: 'SoD & RA',
  },
  // FINISH::Added.by.KWShin.2026.01.06.
  'menu.statistics.abap.os': {
    ko: 'OS',
    ja: 'OS',
    en: 'OS',
  },
  'menu.realtime.detailview.java.ci': {
    ko: 'CI &amp; ICM',
    ja: 'CI &amp; ICM',
    en: 'CI &amp; ICM',
  },
  'menu.realtime.detailview.abap.dump': {
    ko: 'Dump & Log',
    ja: 'ダンプ＆ログ',
    en: 'Dump & Log',
  },
  'menu.user.profile': {
    ko: '사용자 정보',
    ja: 'ユーザー情報',
    en: 'User Information',
  },
  'menu.analstatic.analysis.programHistory': {
    ko: 'Program History',
    ja: 'プログラム履歴',
    en: 'Program History',
  },
  'menu.statistics.abap.user.logon': {
    ko: 'Logon',
    ja: 'ログオン',
    en: 'Logon',
  },
  'menu.preference.general.auth': {
    ko: '권한',
    ja: '権限',
    en: 'Authorization',
  },
  'menu.statistics': {
    ko: '통계',
    ja: '統計',
    en: 'Statistic',
  },
  'menu.realtime': {
    ko: '실시간 대시보드',
    ja: 'リアルタイムダッシュボード',
    en: 'Real-time Dashboard',
  },
  'menu.statistics.java.os.memory': {
    ko: 'Memory',
    ja: 'メモリ',
    en: 'Memory',
  },
  'menu.analstatic.statistics.unused-list': {
    ko: 'Unused List',
    ja: '未使用のリスト',
    en: 'Unused List',
  },
  'menu.analstatic.analysis.owlview': {
    ko: 'OWLView',
    ja: 'OWLView',
    en: 'OWLView',
  },
  'menu.statistics.abap.response.time': {
    ko: 'Response time',
    ja: '応答時間',
    en: 'Response time',
  },
  'menu.preference.general.user': {
    ko: '사용자',
    ja: 'ユーザー',
    en: 'User',
  },
  'menu.preference.general.collector': {
    ko: '수집기',
    ja: 'コレクター',
    en: 'Collector',
  },
  'menu.statistics.abap.os.memory': {
    ko: 'Memory',
    ja: 'メモリ',
    en: 'Memory',
  },
  'menu.statistics.abap.os.cpu': {
    ko: 'CPU',
    ja: 'CPU',
    en: 'CPU',
  },
  'menu.statistics.abap.queue': {
    ko: 'Dipatcher queue',
    ja: 'ディスパッチャキュー',
    en: 'Dipatcher queue',
  },
  'menu.statistics.java.os.cpu': {
    ko: 'CPU',
    ja: 'CPU',
    en: 'CPU',
  },
  'menu.statistics.java.enqueue.lock': {
    ko: 'Enqueue lock',
    ja: 'エンキューロック',
    en: 'Enqueue lock',
  },
  'menu.realtime.detailview.java.db': {
    ko: 'Database',
    ja: 'データベース',
    en: 'Database',
  },
  'menu.statistics.abap.os.fsys': {
    ko: 'File system',
    ja: 'ファイルシステム',
    en: 'File system',
  },
  'menu.statistics.db.oracle.table.space': {
    ko: 'Oracle tablespace',
    ja: 'オラクルのテーブルスペース',
    en: 'Oracle tablespace',
  },
  'menu.statistics.java.miscellaneous': {
    ko: 'Miscellaneous',
    ja: 'その他',
    en: 'Miscellaneous',
  },
  'menu.realtime.detailview.abap.analyzer': {
    ko: 'Context Analyzer',
    ja: 'コンテキストアナライザ',
    en: 'Context Analyzer',
  },
  'menu.realtime.detailview.abap.user': {
    ko: 'User',
    ja: 'ユーザー',
    en: 'User',
  },
  'menu.realtime.overview.whole': {
    ko: 'Whole',
    ja: '全体',
    en: 'Whole',
  },
  'menu.statistics.java.os': {
    ko: 'OS',
    ja: 'OS',
    en: 'OS',
  },
  'menu.preference.prop.prop': {
    ko: 'Properties',
    ja: 'プロパティ',
    en: 'Properties',
  },
  'menu.statistics.abap.user.dup.id': {
    ko: 'Duplication ID',
    ja: '重複ID',
    en: 'Duplication ID',
  },
  'menu.preference.batch': {
    ko: 'Batch History',
    ja: 'バッチ履歴',
    en: 'Batch History',
  },
  'menu.statistics.java.transaction': {
    ko: 'Transaction',
    ja: 'トランザクション',
    en: 'Transaction',
  },
  'menu.preference.alert': {
    ko: 'Alert',
    ja: 'アラート',
    en: 'Alert',
  },
  'menu.preference.alert.kpi': {
    ko: 'KPI Threshold',
    ja: 'KPI閾値',
    en: 'KPI Threshold',
  },
  // BEGIN::Added.by.KWShin.2026.04.23.
  'menu.preference.alert.health': {
    ko: 'Healthy Check',
    en: 'Healthy Check',
    ja: 'Healthy Check',
  },
  'menu.preference.alert.user': {
    ko: '사용자 변동',
    en: 'User Change',
    ja: 'User Change',
  },
  // FINISH::Added.by.KWShin.2026.04.23.
  'menu.preference.alert.dump': {
    ko: 'ABAP Dump',
    ja: 'ABAPダンプ',
    en: 'ABAP Dump',
  },
  'menu.preference.alert.monitor': {
    ko: 'Program Monitor',
    ja: 'プログラムモニター',
    en: 'Program Monitor',
  },
  'menu.preference.alert.whiteList': {
    ko: 'White List',
    ja: 'ホワイトリスト',
    en: 'White List',
  },
  'menu.preference.alert.eos': {
    ko: 'EOS',
    ja: 'EOS',
    en: 'EOS',
  },
  // BEGIN::Added.by.KWShin.2025.12.04.
  'menu.title.reg.home': {
    ko: '첫화면으로 등록',
    en: 'Register as home',
    ja: 'Register as home',
  },
  // FINISH::Added.by.KWShin.2025.12.04.
  // BEGIN::Added.by.KWShin.2026.01.26.
  'menu.preference.batch.sodra': {
    ko: 'SoD & RA 분석 / 이력 관리',
    en: 'SoD & RA Analyze / History',
    cn: 'SoD & RA Analyze / History',
    ja: 'SoD & RA Analyze / History',
  },
  // FINISH::Added.by.KWShin.2026.01.26.
};
